/**
 * Renderer.ts
 *
 * Module for rendering the markup
 */
import { AttributeName, Tags } from "./UiConstants";
/**
 * Create DOM elements from Json structure
 * @param {UiAsJson} schema The Json structure
 * @param {boolean} svg Create svg element instead of html?
 * @return {HTMLElement} HTML elements with tree structure
 */
export function elementFromJson(schema, svg) {
  if (typeof schema.brs === "undefined") {
    schema.brs = true;
  }
  if (!schema.brs) {
    return null;
  }
  if (!schema.tag) {
    schema.tag = Tags.Div;
  }
  let element;
  if (schema.tag === Tags.Svg) {
    svg = true;
  }
  if (svg) {
    element = document.createElementNS("http://www.w3.org/2000/svg", schema.tag);
  } else {
    element = document.createElement(schema.tag);
  }
  if (schema.attributes) {
    let attribute;
    for (let i = 0; i < schema.attributes.length; i++) {
      attribute = schema.attributes[i];
      if (attribute.name === AttributeName.xlinkHref) {
        element.setAttributeNS("http://www.w3.org/1999/xlink", AttributeName.HRef, attribute.value);
      } else {
        element.setAttribute(attribute.name, attribute.value);
      }
    }
  }
  if (schema.id) {
    element.id = schema.id;
  }
  if (schema.classes) {
    let concatClasses = schema.classes.join(" ");
    if (svg) {
      element.setAttribute(AttributeName.Class, concatClasses);
    } else {
      element.className = concatClasses;
    }
  }
  if (schema.innerText && !svg) {
    element.textContent = schema.innerText;
  }
  if (schema.innerHTML && !svg) {
    element.innerHTML = schema.innerHTML;
  }
  if (schema.children) {
    for (let i = 0; i < schema.children.length; i++) {
      // Sometimes IE mis-reports length
      let cur = schema.children[i];
      if (cur) {
        let child = elementFromJson(cur, svg);
        if (child) {
          element.appendChild(child);
        }
      }
    }
  }
  return element;
}